import { useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { sendActivationLink } from "../../../store/actions/clientsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
const ActivationLinkClientPopup = ({activationLinkRec, onHide, activationLinkModalShow, setActivationLinkModalShow}) => {
    const [isAction, setIsAction] = useState(false)
    const [isDone, setIsDone] = useState(false)
    const dispatch = useDispatch();
    const {
        isRecordUpdated,
        error: apiError,
        isLoader,
    } = useSelector(state => state.clients);
    const submitHandler = (mode) => {
        setIsAction(false);
        return dispatch(sendActivationLink({
                clientId: activationLinkRec,
            })).then((payload) => {
                    if(payload?.type === "clients/sendActivationLink/rejected") {
                        return
                    }
                setIsDone(true);
                onHide()
                setActivationLinkModalShow(false)
            })
    }

    return (
        <>
            <Popup
                onHide={() => onHide()}
                size="md"
                show={activationLinkModalShow}
                title={"Resend Activation Link"}
                footer={
                    <>
                        <Button variant="outline-secondary model-btn" className="me-4" onClick={(e) => onHide()}>Cancel</Button>
                        <Button className='btn-primary model-btn' onClick={(e) => submitHandler()}>Confirm</Button>
                    </>
                }
            >
                {isLoader && <Loader />}
                 {
                    apiError &&
                    <Alert variant={'danger'}>
                        {apiError?.message || 'Access denied! Please try again'}
                    </Alert>
                 }
                <div style={{textAlign: "center"}}>
                    {
                        "Are you sure you want to resend activation link to this client?"
                    }
                </div>
            </Popup>
            
        </>
    )
}

export default ActivationLinkClientPopup;